<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
        <path d="M4 20h2v2H4v2H2v-2H0v-2h2v-2h2v2Zm12 0H8v-2h8v2Zm-8-2H6v-2h2v2Zm10 0h-2v-2h2v2ZM6 16H4V8h2v8Zm14 0h-2v-4h-2v-2h2V8h2v8Zm-4-2h-4v-2h4v2Zm-4-2h-2V8h2v4ZM8 8H6V6h2v2Zm8-2h-2v2h-2V6H8V4h8v2Zm6-4h2v2h-2v2h-2V4h-2V2h2V0h2v2Z"></path>
    </svg>
</template>

<script>
export default {
  name: 'PixelMoon',
}
</script>
